import classNames from "classnames/bind";
import React from "react";
import { Info } from "../Info";
import { WithTooltipProps } from "./types";
import styles from "./WithTooltip.module.scss";

const cx = classNames.bind(styles);

/** @deprecated use Tooltip on its own */
const WithTooltip = ({ children, tooltip }: WithTooltipProps) => (
  <>
    {tooltip ? (
      <div className={cx("childrenContainer")}>
        {children}
        <div className={cx("iconContainer")}>
          <Info
            content={tooltip}
            position={["top", "bottom", "left", "right"]}
          />
        </div>
      </div>
    ) : (
      children
    )}
  </>
);

export default WithTooltip;
